import Action from "../actions";

export default function categoryManagementReducer(state = {
    viewList: {
        storeList: [],
        total: 0
    },
    addNew: {},
    viewDetail: {
        original:null,
        editable:null
    },
    storeCategory: {
        categoryList: [],
        total: 0,
        catIds:[]
    }
}, action) {
    if (action.type === Action.SET_CATEGORY_MANAGEMENT) {
        return action.data;
    }
    return state;
}
